import React from "react";
import { useNavigate } from "react-router-dom";

const PortalSelector = () => {
  const navigate = useNavigate();

  const handleChange = (e) => {
    const selected = e.target.value;
    if (selected) {
      navigate(`/${selected}/dashboard`);
    }
  };

  return (
    <div className="w-full">
      {/* <label
        htmlFor="portal"
        className="block mb-2 text-sm font-medium text-gray-700"
      >
        Select Dashboard
      </label> */}
      <select
        id="portal"
        onChange={handleChange}
        defaultValue=""
        className="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200"
      >
        {/* <option value="" disabled>
          Select portal
        </option> */}
        <option value="hrms">HRMS</option>
        <option value="sales">Sales</option>
        <option value="payroll">Payroll</option>
      </select>
    </div>
  );
};

export default PortalSelector;